import React, { useState, useCallback } from "react";
import Dialler from ".";
import CachedImage from "../../../components/common/CachedImage";
import classNames from 'classnames';
import { useSelector } from "react-redux";
import KeypadCallModal from "../../../components/ui/Modals/ModalMessages/KeypadCallModal";
import { useOnlineStatus } from "../../../services/customHooks/useOnlineStatus";

const DiallerButton = ({ geoData, noBalance, }) => {
	const [createConv, setCreateConv] = useState(false);
	const [showTooltip, setShowTooltip] = useState(false);

	const showCreateConversation = useCallback(() => setCreateConv(true), []);
	const closeCreateConversation = useCallback(() => setCreateConv(false), []);


	const selectedDomain = useSelector((state) => state.domain.selectedDomain);
	const isUserOnline = useOnlineStatus();

	const userDomain = selectedDomain || "";
	return (
		<div className="relative">
			<a
				id="recentCallHistory"
				style={{
					borderRadius: "2px",
					boxShadow: "none",
					padding: "",
					color: "#638DFF",
				}}
				onClick={showCreateConversation}
				onMouseEnter={() => setShowTooltip(true)}
				onMouseLeave={() => setShowTooltip(false)}
				className={classNames(`flex justify-center items-center cursor-pointer ${!isUserOnline ? 'disabled' : ''}`)}
			>
				<CachedImage
					image={"/img/phoneicon.png"}
					width={"22px"}
					key={"phone-icon"}
				/>
			</a>

			{/* Enhanced Tailwind Tooltip */}
			{showTooltip && (
				<div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 z-50 bg-header-bg z-[99999999] rounded-xl">
					{/* Tooltip content */}
					<div
						className={`relative bg-gray-900 text-sm rounded-lg px-3 py-2 shadow-lg whitespace-nowrap transition-opacity duration-200 border  border-gray-700 ${userDomain}_font`}
					>
						Call history

						{/* Tooltip arrow */}
						<div className="absolute -top-1.5 left-1/2 transform -translate-x-1/2">
							<div className="w-0 h-0 border-l-4 border-r-4 border-b-4 border-l-transparent border-r-transparent border-b-gray-900"></div>
						</div>
					</div>
				</div>
			)}


			{createConv && (
				<KeypadCallModal
					onClose={closeCreateConversation}
					size="sm"
					title="Recent Calls"
					className="dialler-modal"
				>
					<Dialler
						selectedDomain={selectedDomain}
						onClose={closeCreateConversation}
						geoData={geoData}
						noBalance={noBalance}
					/>
				</KeypadCallModal>
			)}
		</div>
	);
};

export default DiallerButton;